<template>
  <v-container
    :class="{ 'pa-0': $vuetify.breakpoint.smAndDown }"
  >
    <v-row>
      <v-col :md="agent ? 8 : 12" cols="12">
        <div
          v-if="loading"
          class="mt-5"
          style="max-width: 600px;margin-left:auto;margin-right:auto;"
        >
          <h1 class="text-h5">
            Odota hetki
          </h1>
          <v-progress-linear
            color="primary"
            indeterminate
            class="my-4"
          />
        </div>
        <nets v-if="!agent && !loading && identifiedUser && !identifiedUser.ssn"/>
        <pass-code v-else-if="!agent && !property && !loading"/>
        <v-card
          v-else-if="!loading"
          :class="$vuetify.breakpoint.smAndDown ? 'pa-1' : 'pa-5'"
          flat
          class="mb-4"
        >
          <v-card-text class="pt-2 pb-2">
            <img
              v-if="property.logo !== '' && !property.logo?.endsWith('/')"
              :src="property.logo"
              style="max-width:250px;"
              class="mt-4 mb-2"
            >
            <h1 class="text-h4 font-weight-light mb-6 mt-1">
              <template v-if="side !== 'additional'">
                {{ rent ? 'Vuokratoimeksiantosopimus' : 'Toimeksiantosopimus' }}
              </template>
              <template v-else>
                Selostusliite
              </template>
            </h1>
            <v-expansion-panels
              v-if="agent"
              v-model="activePanel"
              focusable
              @change="onChange"
            >
              <v-expansion-panel v-if="showAgreement" class="helmi-form__scroll-target">
                <v-expansion-panel-header
                  :color="activePanel === 0 ? 'primary--text' : 'grey--text text--darken-1'"
                  ripple
                >
                  <template #default="{ open }">
                    <div
                      id="anchor-0"
                      class="helmi-form__scroll-target--anchor"
                    />
                    <v-row
                      align="center"
                      justify="start"
                      no-gutters
                    >
                      <v-col cols="auto">
                        <v-chip
                          class="ml-0 mr-4 black--text"
                          color="primary"
                          :text-color="open ? 'white' : 'primary'"
                          :outlined="!open"
                          small
                          v-text="1"
                        />
                      </v-col>

                      <v-col>
                        <strong>
                          {{ assignmentType }} {{ rent ? 'vuokra' : '' }}toimeksiantosopimus
                        </strong>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  v-if="property && property.kohdenimi"
                  class="pt-4 text-caption property-details"
                >
                  <ol class="pl-0 ml-0">
                    <li class="mt-2">
                      KOHDE
                      <ol>
                        <li>
                          Osoite: <span class="primary--text ml-1">
                            {{ property.kohdenimi }}
                            <span v-if="osake && property.huoneistonro !== ''">
                              {{ property.huoneistonro }}
                            </span>
                            <span v-if="property.postinumero !== ''">
                              {{ property.postinumero }} {{ property.kaupunki }}
                            </span>
                          </span>
                        </li>
                        <li>
                          Kohdenumero: <span class="primary--text ml-1">
                            {{ property.kohdenumero }}</span>
                        </li>
                      </ol>
                    </li>

                    <li class="mt-4">
                      TOIMEKSIANTAJAT
                      <ol>
                        <li v-for="(seller, index) in sellersPreview" :key="index">
                          Toimeksiantaja: <span class="primary--text ml-1">
                            {{ seller.nimi }}
                          </span>
                          <ol>
                            <li>
                              Henkilötunnus / Y-tunnus: <span class="primary--text ml-1">
                                {{ seller.sotu }}</span>
                            </li>
                            <li>
                              Sähköposti: <span class="primary--text ml-1">
                                {{ seller.email }}</span>
                            </li>
                            <li>
                              Puhelin: <span class="primary--text ml-1">
                                {{ seller.puhelin }}</span>
                            </li>
                            <li>
                              Osoite: <span class="primary--text ml-1">
                                {{ seller.osoite }}</span>
                            </li>
                            <li>
                              Postinumero: <span class="primary--text ml-1">
                                {{ seller.postinumero }}</span>
                            </li>
                            <li class="mb-4">
                              Kaupunki: <span class="primary--text ml-1">
                                {{ seller.kaupunki }}</span>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                    <li class="mt-4">
                      VÄLITYSLIIKE
                      <ol>
                        <li
                          v-for="(part, key) in company"
                          :key="key"
                          class="ma-0 text-caption"
                        >
                          {{ key }}:
                          <span class="primary--text ml-1">
                            {{ part }}
                          </span>
                        </li>
                      </ol>
                    </li>
                    <li class="mt-4">
                      EHDOT
                      <p class="primary--text ml-4 mb-0">
                        Ehdot eritellään PDF-dokumentilla.
                      </p>
                    </li>
                    <br>
                    <div
                      v-for="(part, idx) in agreement"
                      :key="idx"
                      class="mb-2"
                    >
                      {{ part.chapter }}.
                      {{ part.props.label.toUpperCase() }}
                      <template v-for="(subPart, index) in part.children">
                        <p
                          v-if="!subPart.hide"
                          :key="index"
                          class="text-caption mb-0 ml-4"
                        >
                          {{ subPart.chapter }}
                          {{ subPart.props && subPart.props.label }}
                          <span
                            v-if="subPart.value && subPart.props.type === 'number'
                              && subPart.props.suffix !== 'kpl'"
                            class="primary--text ml-1"
                          >
                            {{ subPart.value | currency({ style: 'decimal' }) }}
                          </span>
                          <span
                            v-else-if="subPart.value
                              && subPart.component === 'helmi-date-picker'
                              && subPart.value !== '0000-00-00'"
                            class="primary--text ml-1"
                          >
                            {{ subPart.value | date }}
                          </span>
                          <span v-else-if="subPart.value" class="primary--text ml-1">
                            {{ subPart.value }}
                          </span>
                          <span
                            v-if="subPart.value && subPart.props && subPart.props.suffix"
                            class="primary--text ml-1"
                          >
                            {{ subPart.props.suffix }}
                          </span>
                        </p>
                      </template>
                    </div>
                  </ol>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel v-if="showAdditional">
                <v-expansion-panel-header
                  :color="activePanel === 1 ? 'primary--text' : 'grey--text text--darken-1'"
                  ripple
                >
                  <template #default="{ open }">
                    <div
                      id="anchor-1"
                      class="helmi-form__scroll-target--anchor"
                    />
                    <v-row
                      align="center"
                      justify="start"
                      no-gutters
                    >
                      <v-col cols="auto">
                        <v-chip
                          class="ml-0 mr-4 black--text"
                          color="primary"
                          :text-color="open ? 'white' : 'primary'"
                          :outlined="!open"
                          small
                        >
                          {{ side === 'additional' ? 1 : 2 }}
                        </v-chip>
                      </v-col>

                      <v-col>
                        <strong>{{ assignmentType }} selostusliite</strong>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="property && property.kohdenimi">
                  <p class="text-caption mt-4 property-details">
                    <ol style="padding-left:0">
                      <li>
                        TOIMEKSIANTO
                        <ol>
                          <li v-for="(item, idx) in assignment" :key="idx">
                            {{ idx }}: <span class="primary--text ml-1">
                              {{ item }}</span>
                          </li>
                        </ol>
                      </li>
                      <li>
                        PERUSTIEDOT
                        <ol>
                          <li v-for="(item, idx) in basicDetails" :key="idx">
                            {{ idx }}: <span class="primary--text ml-1">
                              {{ item }}</span>
                          </li>
                        </ol>
                      </li>
                      <li class="mt-4">
                        KUSTANNUKSET
                        <ol>
                          <li v-for="(item, idx) in priceAndExpences" :key="idx">
                            {{ idx }}: <span class="primary--text ml-1">
                              {{ item }}</span>
                          </li>
                        </ol>
                      </li>
                      <li class="mt-4">
                        TILOJEN VARUSTUS
                        <ol>
                          <li v-for="(item, idx) in equipment" :key="idx">
                            {{ idx }}: <span class="primary--text ml-1">
                              {{ item }}</span>
                          </li>
                          <template v-if="osake">
                            <li>Asukkaan käytössä olevien tilojen hallintaperuste</li>
                            <ol>
                              <li>
                                Yhtiöjärjestyksen mukainen: <span class="primary--text ml-1">
                                  {{ additionalDetails.apartmentManagementCriterionOccupant
                                    ? additionalDetails.apartmentManagementCriterionOccupant
                                      .children.articlesOfAssociationOccupant.value : '' }}</span>
                              </li>
                              <li>
                                Muu hallintaperuste:
                                <span class="primary--text ml-1">
                                  {{ additionalDetails.apartmentManagementCriterionOccupant
                                    ? additionalDetails.apartmentManagementCriterionOccupant
                                      .children.apartmentManagementCriterionOccupantOther.value :
                                      '' }}
                                </span>
                              </li>
                            </ol>
                          </template>
                        </ol>
                      </li>
                      <li v-if="osake" class="mt-4">
                        TALOYHTIÖ JA ISÄNNÖITSIJÄ
                        <ol>
                          <li v-for="(item, idx) in housingCompany" :key="idx">
                            {{ idx }}: <span class="primary--text ml-1">
                              {{ item }}</span>
                          </li>
                        </ol>
                      </li>
                      <li v-else class="mt-4">
                        KIINTEISTÖ JA RAKENNUKSET
                        <ol>
                          <li v-for="(item, idx) in propertyDetails" :key="idx">
                            {{ idx }}: <span class="primary--text ml-1">
                              {{ item }}</span>
                          </li>
                        </ol>
                      </li>
                      <li class="mt-4">
                        LÄHIPALVELUT
                        <ol>
                          <li v-for="(item, idx) in otherDetails" :key="idx">
                            {{ idx }}: <span class="primary--text ml-1">
                              {{ item }}</span>
                          </li>
                        </ol>
                      </li>

                      <template v-for="(part, idx) in additionalDetails">
                        <li
                          v-if="!removedFields.includes(idx)"
                          :key="idx"
                          class="mt-4"
                        >
                          {{ part.props.label.toUpperCase() }}
                          <ol>
                            <template v-for="(subPart, index) in part.children">
                              <li
                                v-if="subPart.component !== 'helmi-subheader'"
                                :key="index"
                              >
                                {{ subPart.props && subPart.props.label }}
                                <span
                                  v-if="subPart.value && subPart.props.type === 'number'
                                    && subPart.props.suffix !== 'kpl'"
                                  class="primary--text ml-1"
                                >
                                  {{ subPart.value | currency({ style: 'decimal' }) }}
                                </span>
                                <span
                                  v-else-if="
                                    subPart.value
                                      && subPart.component === 'helmi-date-picker'
                                      && subPart.value !== '0000-00-00'
                                  "
                                  class="primary--text ml-1"
                                >
                                  {{ subPart.value | date }}
                                </span>
                                <span v-else-if="subPart.value" class="primary--text ml-1">
                                  {{ subPart.value }}
                                </span>
                                <span
                                  v-if="
                                    subPart.props
                                      && subPart.value
                                      && subPart.props.suffix
                                  "
                                  class="primary--text"
                                >
                                  {{ subPart.props.suffix }}
                                </span>
                              </li>
                            </template>
                          </ol>
                        </li>
                      </template>
                    </ol>
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  :color="activePanel === 2 ? 'primary--text' : 'grey--text text--darken-1'"
                  ripple
                >
                  <template #default="{ open }">
                    <div
                      id="anchor-2"
                      class="helmi-form__scroll-target--anchor"
                    />
                    <v-row
                      align="center"
                      justify="start"
                      no-gutters
                    >
                      <v-col cols="auto">
                        <v-chip
                          class="ml-0 mr-4 black--text"
                          color="primary"
                          :text-color="open ? 'white' : 'primary'"
                          :outlined="!open"
                          small
                        >
                          {{ side ? 2 : 3 }}
                        </v-chip>
                      </v-col>

                      <v-col>
                        <strong>Allekirjoitukset</strong>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="property && property.kohdenimi" class="pt-4">
                  <p
                    v-for="(signature, key) in signatures"
                    :key="key"
                    class="ma-0 text-caption"
                  >
                    {{ signature.name }}:
                    <span class="primary--text ml-1">
                      Allekirjoitettu sähköisesti
                      {{ signature.created | date }}
                    </span>
                  </p>
                  <p v-if="signatures.length < 1" class="mb-0">
                    Ei allekirjoituksia
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-alert
              v-if="!agent && identifiedUser && identifiedUser.ssn"
              icon="assignment"
              prominent
              border="left"
              dark
              class="mt-4"
              color="blue"
            >
              <v-row align="center">
                <v-col :class="$vuetify.breakpoint.xs ? 'pb-0' : ''" class="grow">
                  <template v-if="identifiedUserHasSigned">
                    <h2 class="mb-1">
                      Kiitos allekirjoituksestasi!
                    </h2>
                    <p>Voit nyt ladata allekirjoitetun sopimuksen.</p>
                  </template>
                  <b>{{ property.kohdenimi }}</b><br>
                  {{ side === 'additional'
                    ? 'Selostusliite'
                    : 'Toimeksiantosopimus' }} | {{ commissionAgreements[id].created | date }}
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pt-1' : ''" class="shrink">
                  <v-btn
                    color="white"
                    dark
                    depressed
                    outlined
                    large
                    @click="printPdf()"
                  >
                    Lataa PDF
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
            <v-alert
              v-if="identifiedUser && identifiedUser.ssn && !agent"
              icon="person"
              prominent
              text
              class="mt-4"
              :color="identifiedUserHasSigned ? 'green' : 'blue'"
            >
              <v-row align="center">
                <v-col class="grow">
                  <b>{{ identifiedUser.name }}</b><br>
                  {{ identifiedUser.ssn }}
                </v-col>
                <v-col :class="$vuetify.breakpoint.xs ? 'pt-1' : ''" class="shrink">
                  <v-dialog
                    v-if="!identifiedUserHasSigned"
                    v-model="signDialog"
                    persistent
                    max-width="400"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="blue"
                        depressed
                        dark
                        large
                        v-on="on"
                      >
                        Allekirjoita
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5">
                        Haluatko varmasti allekirjoittaa?
                      </v-card-title>
                      <v-card-text class="pt-3">
                        Olet allekirjoittamassa {{ side === 'additional'
                          ? 'selostusliitteen' : 'toimeksiantosopimuksen' }}, ja sitoudut siinä
                        määriteltyihin ehtoihin.
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer/>
                        <v-btn text @click="signDialog = false">
                          Peruuta
                        </v-btn>
                        <v-btn
                          color="primary"
                          text
                          @click="sign()"
                        >
                          Allekirjoita
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <span v-else>Allekirjoitettu</span>
                </v-col>
              </v-row>
            </v-alert>
          </v-card-text>
          <v-card-actions v-if="!agent" class="px-4">
            <v-spacer/>
            <v-btn
              x-large
              color="blue"
              class="px-4"
              outlined
              @click="logout()"
            >
              Poistu
              <v-icon class="ml-2">
                logout
              </v-icon>
            </v-btn>
          </v-card-actions>
          <v-card-actions v-if="agent" class="pt-4 px-4">
            <v-spacer/>
            <v-btn
              color="primary"
              class="mx-1"
              depressed
              outlined
              large
              :disabled="signatures.length > 0"
              @click="goBack()"
            >
              Muokkaa
            </v-btn>
            <v-btn
              color="primary"
              class="mx-1"
              depressed
              outlined
              dark
              large
              @click="printPdfWrapper()"
            >
              Lataa PDF
            </v-btn>
            <v-btn
              color="primary"
              class="mx-1"
              depressed
              dark
              large
              @click="openSendLinksDialog"
            >
              {{ $vuetify.breakpoint.smAndDown ? 'Lähetä' : 'Lähetä allekirjoitettavaksi' }}
            </v-btn>
            <v-dialog
              v-if="agent"
              v-model="sendLinksDialog"
              persistent
              max-width="400"
            >
              <v-card>
                <v-card-title class="text-h5">
                  Lähetä allekirjoitettavaksi
                </v-card-title>
                <v-card-text class="pt-3">
                  <p class="mb-8">
                    Olet lähettämässä allekirjoituslinkit ja pääsykoodit seuraaviin toimeksiantajien
                    sähköpostiosoitteisiin:
                  </p>

                  <v-form
                    ref="personForm"
                    v-model="emailsValid"
                  >
                    <div v-for="(seller, idx) in sellersForSending" :key="idx">
                      <v-row
                        class="mx-0 mb-0"
                        :class="{ 'mb-2' : signatures
                          .some(s => +s.person_id === +seller.henkilo_id) }"
                      >
                        <v-checkbox
                          v-model="seller.send"
                        />
                        <v-text-field
                          v-model="seller.email"
                          outlined
                          class="mt-1"
                          :label="`Sähköposti ${seller.nimi}`"
                          :rules="seller.send ? [rules.required, rules.email] : []"
                          persistent-hint
                          :hint="signatures.some(s => +s.person_id === +seller.henkilo_id) ?
                            `HUOM! ${seller.nimi} on jo allekirjoittanut` : null"
                          required
                        />
                      </v-row>
                    </div>
                  </v-form>

                  <v-alert v-if="!sellers?.some(i => i.nimi)" type="warning">
                    Ei allekirjoittajiksi merkittyjä toimeksiantajia
                  </v-alert>
                  <v-alert
                    v-if="sellersForSending?.some(i => i.nimi && !i.email && i.send)"
                    type="warning"
                  >
                    Ainakin yhdeltä toimeksiantajalta puuttuu sähköpostiosoite
                  </v-alert>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn text @click="sendLinksDialog = false">
                    Peruuta
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    :disabled="!
                      sellers.some(i => i.nimi)
                      || !sellersForSending.some(s => s.send)
                      || !emailsValid"
                    @click="sendLinks()"
                  >
                    Lähetä
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        v-if="agent && !loading"
        cols="12"
        md="4"
      >
        <v-card
          color="transparent"
          class="elevation-0"
          :class="$vuetify.breakpoint.smAndDown ? 'mt-0 px-3' : 'mt-10 px-4'"
        >
          <h2 class="text-h5 mb-6">
            Tapahtumat
          </h2>
          <v-timeline dense>
            <v-timeline-item
              v-for="(item, i) in log"
              :key="i"
              color="primary"
              small
            >
              <div
                class="elevation-0"
              >
                <p class="my-2 text-caption">
                  <b class="primary--text">
                    {{ item.logTimeStamp | date }} klo
                    {{ item.logTimeStamp | date({ type: 'time' }) }}
                  </b>
                  <br>
                  {{ item.name }} {{ item.description }}
                </p>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="messageBox"
      :color="messageColor"
    >
      {{ message }}
    </v-snackbar>
    <v-dialog
      v-model="showChangeDialog"
      persistent
      max-width="440"
    >
      <helmi-detect-changes-return/>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import moment from 'moment';
import _ from 'lodash';
import { sleep } from '@/utils';
import { apiPost, apiGet } from '../api';

const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('../assets/fonts.js');

export default {
  name: 'CommissionAgreementPreview',

  components: {
    'pass-code': () => import('@/components/CommissionAgreementPassCode'),
    nets: () => import('@/components/CommissionAgreementNets'),
    'helmi-detect-changes-return': () => import('@/components/CommissionAgreementChangesReturn'),
  },
  data: () => ({
    activePanel: 0,
    messageBox: false,
    messageColor: 'black',
    clauses: {},
    message: '',
    emailsValid: false,
    signDialog: false,
    sendLinksDialog: false,
    showChangeDialog: false,
    loading: true,
    sellersForSending: [],
    logItems: [],
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Virheellinen sähköpostiosoite.';
      },
    },
    removedFields: ['foundationOfTheCompany', 'reportedArea', 'apartmentManagementCriterion', 'apartmentManagementCriterionOccupant'],
    nonHabitable: [
      '5',
      '6',
      '7',
      '16',
      '19',
      '20',
      '23',
      '24',
    ],
    propertyTypes: {
      0: 'Omakotitalo',
      1: 'Rivitalo',
      2: 'Kerrostalo',
      3: 'Loma-asunto',
      4: 'Tontti',
      5: 'Liiketila',
      6: 'Autotalli',
      7: 'Varasto',
      8: 'Paritalo',
      9: 'Erillistalo',
      10: 'Lomahuoneisto',
      11: 'Loma-asunto ulkomailla',
      12: 'Lomaosake',
      13: 'Omakotitalotontti',
      14: 'Vapaa-ajan tontti',
      15: 'Rivitalotontti',
      16: 'Autopaikka',
      17: 'Maatila',
      18: 'Metsätila',
      19: 'Toimistotila',
      20: 'Tuotantotila',
      21: 'Puutalo-osake',
      22: 'Luhtitalo',
      23: 'Muu toimitila',
      24: 'Muu',
    },
  }),
  computed: {
    ...mapGetters({
      agent: 'agent',
    }),
    ...mapState({
      commissionAgreements: state => state.commissionAgreement.byId,
    }),
    side() {
      return this.$route.params.side || '';
    },
    showAgreement() {
      return (!this.$route.params.side || this.$route.params.side === 'agreement');
    },

    showAdditional() {
      return (!this.$route.params.side || this.$route.params.side === 'additional');
    },
    assignmentType() {
      // if (this.rent) {
      //   return 'Vuokrakohteen';
      // }
      if (this.osake) {
        return 'Huoneiston';
      }
      return 'Kiinteistön';
    },

    assignmentTitle() {
      if (this.osake) {
        return 'HUONEISTO';
      }
      return 'KIINTEISTÖ / VUOKRAOIKEUS RAKENNUKSINEEN';
    },

    type() {
      if (this.rent && this.osake) return 'rentalCondominium';
      if (this.rent) return 'rentalProperty';
      if (this.osake) return 'condominium';
      return 'property';
    },

    company() {
      if (this.property && this.property.companyName) {
        return {
          'Välitysliikkeen rekisteröity toiminimi': this.property.companyName,
          'Välitysliikkeen osoite': this.property.companyAddress,
          'Välitysliikkeen Y-tunnus': this.property.companyVat,
          'Asiaa hoitava henkilö': this.property.agentName,
          Puhelin: this.property.agentPhone,
          Sähköposti: this.property.agentEmail,
        };
      }
      return {};
    },

    assignment() {
      return {
        Kohdenumero: this.property.kohdenumero,
        ...!this.osake && { 'Kiinteistötunnus / laitostunnus': this.property.omkkiinteistotunnus },
        ...!this.osake && { 'Tontin omistus': this.property.tontinomistus < 1 ? 'Oma tontti' : 'Vuokraoikeus' },
        Kohdetyyppi: this.propertyTypes[this.property.kohdetyyppi],
        Uudiskohde: +this.property.uudiskohde > 0 ? 'Kyllä' : 'Ei',
        Tarjouskauppa: +this.property.offerbid > 0 ? 'Kyllä' : 'Ei',
      };
    },

    priceAndExpences() {
      let expences = {};
      if (this.osake) {
        expences = {
          Autopaikka: +this.property.autopaikka > 0 ? `${this.$options.filters.currency(this.property.autopaikka)} / kk` : '',
          Vesimaksu: +this.property.vesimaksu > 0 ? `${this.$options.filters.currency(this.property.vesimaksu)} / kk` : '',
          'Lisätietoa vesimaksusta': this.property.vesimaksukuvaus,
          ...!this.rent && { Hoitovastike: +this.property.hoitovastike > 0 ? `${this.$options.filters.currency(this.property.hoitovastike)} / kk` : ' ' },
          ...!this.rent && { Rahoitusvastike: +this.property.rahoitusvastike > 0 ? `${this.$options.filters.currency(this.property.rahoitusvastike)} / kk` : ' ' },
          ...!this.rent && { Yhtiövastike: +this.property.yhtiovastike > 0 ? `${this.$options.filters.currency(this.property.yhtiovastike)} / kk` : ' ' },
        };
      } else if (!this.rent) {
        expences = {
          Kiinteistövero: +this.property.kiinteistovero > 0 ? `${this.$options.filters.currency(this.property.kiinteistovero)} / v` : '',
          'Tontin vuokra': +this.property.tontinomistus > 0 ? `${this.$options.filters.currency(this.property.omktontinvuokra)} / v` : '',
          'Tontin vuokrasopimus päättyy': +this.property.tontinomistus > 0 ? this.property.vuokrasopimuspaattyy : '',
        };
      }

      const priceAndExpences = {
        Energiankulutus: this.property.sahkonkulutus,
        ...expences,
        'Muut maksut': this.property.muutmaksut,
      };
      return priceAndExpences;
    },

    basicDetails() {
      const details = {
        Katuosoite: this.property.kohdenimi,
      };
      if (this.osake) {
        details['Huoneiston nro'] = this.property.huoneistonro;
      }
      details.Postinumero = this.property.postinumero;
      details.Kaupunki = this.property.kaupunki;
      details.Kaupunginosa = this.property.kaupunginosa;
      details.Maakunta = this.property.maakunta;
      details['Kunta vai kaupunki'] = +this.property.kuntakaupunki > 0 ? 'Kunta' : 'Kaupunki';
      details.Huonekuvaus = this.property.huokuvaus;
      details.Huoneita = +this.property.huoneluku !== 1000 ? +this.property.huoneluku + 1 : ' ';
      if (this.osake) {
        details['Huoneiston kerros'] = this.property.huoneistonkrs;
        if (+this.property.osakemaara > 0 && +this.property.osakenumerot > 0) {
          details.Osaketiedot = `${this.property.osakenumerot} - ${this.property.osakemaara}`;
        } else {
          details.Osaketiedot = '';
        }
      }

      const conditions = {
        0: 'Hyvä',
        1: 'Tyydyttävä',
        2: 'Välttävä',
        3: 'Erinomainen',
        4: 'Huono',
        5: 'Purkukuntoinen',
        6: '',
      };
      details.Kuntoluokitus = conditions[+this.property.kuntoluokitus];
      details['Kunto (tarkennus)'] = this.property.kunto;

      const asbesti = {
        0: '',
        1: 'Kyllä',
        2: 'Ei',
      };
      details['Asbestikartoitus tehty'] = asbesti[+this.property.asbestikartoitus];
      if (this.osake) {
        details['Yhtiö perustettu ennen 1.1.1992'] = this.additionalDetails?.foundationOfTheCompany?.children
          ?.foundedBefore1992.value;
      }
      details[this.nonHabitable.includes(this.property.kohdetyyppi)
        ? 'Pinta-ala' : 'Asuinpinta-ala'] = +this.property
        .pintaala > 0 ? `${this.$options.filters.currency(this.property
          .pintaala, { style: 'decimal' })} m²` : '';

      details['Kokonaispinta-ala'] = +this.property
        .kokonaisala > 0 ? `${this.$options.filters.currency(this.property
          .kokonaisala, { style: 'decimal' })} m²` : '';

      details['Muu pinta-ala'] = +this.property
        .muuala > 0 ? `${this.$options.filters.currency(this.property
          .muuala, { style: 'decimal' })} m²` : '';

      details['Lisätietoja pinta-aloista'] = this.property.muualaselite;

      if (!this.osake) {
        details['Tontin pinta-ala'] = +this.property.omktontinpinta > 0 ? `${this.$options.filters.currency(this.property.omktontinpinta, { style: 'decimal' })} m²` : ' ';
        details['Tontin vuokranantaja'] = this.property.landlord;

        // Lot overrides
        if ([4, 13, 14, 15].includes(+this.property.kohdetyyppi)) {
          details['Tontin pinta-ala'] = +this.property.pintaala > 0 ? `${this.$options.filters.currency(this.property.pintaala, { style: 'decimal' })} m²` : ' ';

          if (details['Pinta-ala']) {
            details['Pinta-ala'] = '';
          }

          if (details['Asuinpinta-ala']) {
            details['Asuinpinta-ala'] = '';
          }
        }
      }

      if (!this.osake && this.commissionAgreements[this.id].created >= '2022-04-30 00:00:00') {
        details.Rakennusvuosi = +this.property.vuosi || ' ';
        details['Kattotyyppi / kate'] = this.property.omkkattotyyppi;
        details.Ilmanvaihto = this.property.ilmanvaihto;
        details.Rakennusmateriaalit = this.property.omkrakennusmateriaali;
        details.Energiatodistus = this.property.omkenergiatodistus;
        details.Lämmitysjärjestelmä = this.property.omklammitys;
        details['Kiinteistön lisätiedot'] = this.property.kiinteistonlisatiedot;
      }

      if (this.osake) {
        details['Yhtiöjärjestyksen mukainen pinta-ala'] = `${this.$options.filters.currency(this.property
          .yhtpintaala, { style: 'decimal' })} m²`;

        if (this.additionalDetails.reportedArea) {
          details['Pinta-ala isännöitsijäntodistuksen mukainen'] = this.additionalDetails.reportedArea?.children.superintendentCertificate.value;
          details['Pinta-ala yhtiöjärjestyksen mukainen'] = this.additionalDetails.reportedArea?.children.articlesOfAssociation.value;
          details['Pinta-ala toimeksiantajan ilmoittama'] = this.additionalDetails.reportedArea?.children.clientReport.value;
          details['Pinta-ala tarkistusmitattu'] = this.additionalDetails.reportedArea?.children.reviewMeasured
            .value;
        }
        details['Yhtiöjärjestyksen mukainen huoneistoselitelmä'] = this.property.huoneistoselitelma;
        details['Yhtiöjärjestyksen mukainen hallintaperuste'] = this.additionalDetails?.apartmentManagementCriterion?.children
          .articlesOfAssociation2.value;
        details['Muu hallintaperuste'] = this.additionalDetails?.apartmentManagementCriterion?.children
          .apartmentManagementCriterionOther.value;
      }

      return details;
    },

    equipment() {
      const saunaOptions = {
        0: '',
        1: 'Oma sauna',
        2: 'Taloyhtiössä sauna',
        3: 'Oma sauna + taloyhtiössä sauna',
      };
      const habitableEquipment = {
        Keittiö: this.property.keittio,
        'Keittiön lattia': this.property.keittiolattia,
        'Keittiön seinät': this.property.keittioseinat,
        'WC-tilojen kuvaus': this.property.wctilat,
        'Kylpyhuoneen varustus': this.property.kph,
        'Kylpyhuoneen lattia': this.property.kphlattia,
        'Kylpyhuoneen seinät': this.property.kphseinat,
        'Kodinhoitohuoneen kuvaus': this.property.khh,
        'Olohuoneen kuvaus': this.property.ohkuvaus,
        'Olohuoneen lattia': this.property.ohlattia,
        'Olohuoneen seinät': this.property.ohseinat,
        'Makuuhuoneiden kuvaus': this.property.mhkuvaus,
        'Makuuhuoneen lattia': this.property.mhlattia,
        'Makuuhuoneen seinät': this.property.mhseinat,
        'Muut tilat ja niiden varustelu': this.property.otherspaces,
        Sauna: saunaOptions[this.property.saunatiedot],
        'Saunan lisätiedot': this.property.saunalisatiedot,
        'Asunnossa on parveke': +this.property.parveke > 0 ? 'Kyllä' : 'Ei',
        'Parvekkeen lisätiedot': this.property.parvekesuunta,
        Säilytystilat: this.property.sailytystilat,
      };

      if (this.commissionAgreements[this.id].created < '2021-03-31 10:00:00') {
        delete habitableEquipment['WC-tilojen kuvaus'];
        delete habitableEquipment['Olohuoneen kuvaus'];
        delete habitableEquipment['Makuuhuoneiden kuvaus'];
      }

      if (this.commissionAgreements[this.id].created < '2022-04-30 00:00:00') {
        delete habitableEquipment['Kodinhoitohuoneen kuvaus'];
        delete habitableEquipment['Muut tilat ja niiden varustelu'];
      }

      const otherEquipment = {};
      otherEquipment[this.nonHabitable.includes(this.property.kohdetyyppi)
        ? 'Tehdyt korjaukset' : 'Asuntoon tehdyt korjaukset'] = this.property.remontit;

      otherEquipment['Auton säilytys'] = this.property.autonsailytys;
      otherEquipment[this.osake ? 'Huoneiston lisätiedot' : 'Rakennuksen lisätiedot'] = this.property.rakennuksentiedot;
      return {
        ...habitableEquipment,
        ...otherEquipment,
      };
    },

    propertyDetails() {
      const noEnergyClass = {
        ei: 'Ei lain edellyttämää energiatodistusta',
        eivaadita: 'Ei vaadita',
      };
      const shore = {
        1: 'Oma ranta',
        2: 'Rantaoikeus',
        3: 'Oikeus vesialueisiin',
        4: 'Yhteisranta',
        5: 'Ei luokiteltu',
      };
      const shoreTypes = {
        1: 'Järvi',
        2: 'Lampi',
        3: 'Joki',
        4: 'Muu',
      };
      const zoning = {
        0: 'Asemakaava',
        1: 'Yleiskaava',
        2: 'Ei kaavaa',
        3: 'Osayleiskaava',
        4: 'Rakennuskaava',
        5: 'Ranta-asemakaava',
        6: 'Rantakaava',
        7: 'Suunnittelutarvealue',
        8: 'Rakennuslupa',
        9: 'Poikkeamispäätös',
        10: 'Rakennuskielto',
        11: 'Toimenpidekielto',
        12: 'Lopputarkastus',
        13: 'Käyttöönottotarkastus',
        14: 'Haja-asutusalue',
      };
      return {
        Rakennusvuosi: +this.property.vuosi > 0 ? this.property.vuosi : '',
        Rakennusmateriaali: this.property.omkrakennusmateriaali,
        'Kattotyyppi/kate': this.property.omkkattotyyppi,
        Energiatodistus: noEnergyClass[this.property.omkenergiatodistus]
          || this.property.omkenergiatodistus,
        Kerrosluku: +this.property.omkkerrosluku > 0 ? this.property.omkkerrosluku : '',
        Ilmanvaihto: this.property.ilmanvaihto,
        Lämmitysjärjestelmä: this.property.omklammitys,
        'Tila/tontti': +this.property.tilatontti > 0 ? 'Tila' : 'Tontti',
        Kiinteistötunnus: this.property.omkkiinteistotunnus,
        Ranta: shore[this.property.omaranta] || '',
        'Rannan tyyppi': shore[this.property.omaranta] ? (shoreTypes[this.property.rannantyyppi] || 'Meri') : '',
        'Tilan nimi': this.property.tilannimi,
        'Kiinteistön rek. pvm': this.$options.filters.date(this.property.omkkiintrek),
        Kaavoitustilanne: zoning[this.property.omkkaavoitus],
        Määräala: +this.property
          .maaraala > 0 ? `${this.$options.filters.currency(this.property
            .maaraala, { style: 'decimal' })} m²` : '',
        'Tontin pinta-ala': +this.property
          .omktontinpinta > 0 ? `${this.$options.filters.currency(this.property
            .omktontinpinta, { style: 'decimal' })} m²` : '',
        Rakennusoikeus: +this.property
          .omkrakennusoikeus > 0 ? `${this.$options.filters.currency(this.property
            .omkrakennusoikeus, { style: 'decimal' })} m²` : '',
        'Lisätietoja rakennusoikeudesta': this.property.rakennusoikeuslisatieto,
        Liittymät: this.property.omkkunnallistekniikka,
        'Liittymien lisätiedot': this.property.liittymienlisatiedot,
        'Kiinteistön lisätiedot': this.property.kiinteistonlisatiedot,
      };
    },

    housingCompany() {
      const noEnergyClass = {
        ei: 'Ei lain edellyttämää energiatodistusta',
        eivaadita: 'Ei vaadita',
      };
      const options = {
        0: 'Pinta-ala',
        1: 'Osakemäärä',
        2: 'Jyvitys',
        3: 'Lukumäärä',
      };

      const secondOptions = {
        0: 'Ei',
        1: 'Kyllä',
        2: 'Kyllä, osakkailla',
        3: 'Kyllä, taloyhtiöllä',
        4: 'Kyllä, osakkailla ja taloyhtiöllä',
      };

      const company = {
        'Taloyhtiön nimi': this.property.taloyhtio.yhtionimi,
        'Taloyhtiön y-tunnus': this.property.taloyhtio.ytunnus,
        'Kiinteistön rakennusvuosi': this.property.taloyhtio.rakennusvuosi,
        'Taloyhtiön katuosoite': this.property.taloyhtio.osoite,
        Rakennusmateriaali: this.property.taloyhtio.rakennusmateriaali,
        Kattotyyppi: this.property.taloyhtio.kattotyyppi,
        Lämmitysjärjestelmä: this.property.taloyhtio.lammitys,
        Ilmanvaihto: this.property.taloyhtio.ilmanvaihto,
        'TV-järjestelmä': this.property.taloyhtio.tvjarjestelma,
        'Talossa kerroksia': +this.property.taloyhtio.kerroksia > 0 ? this.property.taloyhtio.kerroksia : '',
        Hissi: +this.property.taloyhtio.hissi > 0 ? 'Kyllä' : 'Ei',
        'Toteutetut autopaikat': +this.property.taloyhtio.autopaikat > 0 ? this.property.taloyhtio.autopaikat : '',
        Energiatodistus: noEnergyClass[this.property.taloyhtio.energiatodistus]
          || this.property.taloyhtio.energiatodistus,
        Vastikeperuste: options[this.property.taloyhtio.vastikeperuste],
        'Asuntoja yhteensä': +this.property.taloyhtio.asuinhuoneistoja > 0 ? this.property.taloyhtio.asuinhuoneistoja : '',
        'Asuntojen pinta-ala yhteensä': +this.property.taloyhtio.asuntojenpintaala > 0 ? `${this.$options.filters.currency(this.property
          .taloyhtio.asuntojenpintaala, { style: 'decimal' })} m²` : '',
        'Yhtiön hallinnassa olevat asunnot': this.property.taloyhtio.hallinnassaolevatasunnot,
        'Liiketiloja yhteensä': +this.property.taloyhtio.liiketilat > 0 ? this.property.taloyhtio.liiketilat : '',
        'Liiketilojen pinta-ala yhteensä': +this.property
          .taloyhtio.liiketilojenpintaala > 0 ? `${this.$options.filters.currency(this.property
            .taloyhtio.liiketilojenpintaala, { style: 'decimal' })} m²` : '',
        'Yhtiön hallinnassa olevat liiketilat': this.property.taloyhtio.hallinnassaolevatliiketilat,
        'Tehdyt korjaukset': this.property.taloyhtio.korjaukset,
        'Tulevat korjaukset': this.property.taloyhtio.tulevatkorj,
        'Tontin omistus': +this.property.taloyhtio.tontti > 0 ? 'Oma tontti' : 'Vuokratontti',
        'Tontin vuokranantaja': this.property.taloyhtio.vuokranantaja,
        'Vuokran määrä': +this.property.taloyhtio.vuokranmaara > 0 ? this.$options.filters.currency(this.property.taloyhtio.vuokranmaara) : '',
        'Tontin vuokrasopimus päättyy': this.property.taloyhtio.vuokrasopimuspaattyy,
        'Tontin pinta-ala': +this.property
          .taloyhtio.tontinala > 0 ? `${this.$options.filters.currency(this.property
            .taloyhtio.tontinala, { style: 'decimal' })} m²` : '',
        'Taloyhtiön lainan määrä': +this.property.taloyhtio.lainanmaara > 0 ? this.$options.filters.currency(this.property.taloyhtio.lainanmaara) : '',
        'Taloyhtiön lainan päivämäärä': (this.property.taloyhtio.lainapvm && this.property.taloyhtio.lainapvm !== '0000-00-00') ? this.$options.filters.date(this.property.taloyhtio.lainapvm) : '',
        Lunastuslauseke: secondOptions[this.property.taloyhtio.lunastuslauseke],
        'Yhteiset tilat': this.property.taloyhtio.yhteisettilat,
        Isännöitsijätoimisto: this.property.taloyhtio.isannoitsijatsto,
        Isännöitsijä: this.property.taloyhtio.isannoitsija,
        'Isännöitsijätoimiston osoite': this.property.taloyhtio.isannoitsijaosoite,
        'Isännöitsijätoimiston puhelin': this.property.taloyhtio.isannoitsijapuh,
        'Isännöitsijätodistuksen päivämäärä': this.property.taloyhtio.isannoitsijapvm && this.$options.filters.date(this.property.taloyhtio.isannoitsijapvm),
        Kiinteistönhoito: this.property.taloyhtio.kiinteistonhuolto,
        'Lisätietoja taloyhtiöstä': this.property.taloyhtio.lisatiedot,
      };
      return company;
    },

    otherDetails() {
      return {
        Kauppa: this.property.kauppa,
        Liikenneyhteydet: this.property.liikenneyhteydet,
        Koulu: this.property.koulu,
        Päiväkoti: this.property.paivakoti,
      };
    },

    osake() {
      return this.property && +this.property.osakevaikiinteisto > 0;
    },
    rent() {
      return this.property && +this.property.onkovuokrakohde > 1;
    },
    mainTitle() {
      if (this.rent) {
        return 'VUOKRATOIMEKSIANTO';
      }
      return 'TOIMEKSIANTO';
    },
    id() {
      return +this.$route.params.id;
    },
    pid() {
      if (this.commissionAgreements && this.commissionAgreements[this.id]) {
        return this.commissionAgreements[this.id].person;
      }
      return null;
    },
    additionalDetailsIndex() {
      return 8;
    },
    log() {
      if (this.commissionAgreements && this.commissionAgreements[this.id]) {
        const items = [
          {
            logTimeStamp: this.commissionAgreements[this.id].created,
            name: `${this.side === 'additional' ? 'Selostusliite' : 'Toimeksiantosopimus'} luotu`,
            description: '',
          },
          ...this.logItems,
        ];
        return items;
      }
      return [];
    },
    logo() {
      if (this.commissionAgreements && this.commissionAgreements[this.id].logo) {
        if (this.commissionAgreements[this.id].logo?.endsWith('data:image/jpg;base64,')) return false;

        return this.commissionAgreements[this.id].logo;
      }
      return false;
    },
    agreement() {
      if (this.commissionAgreements && this.commissionAgreements[this.id]) {
        return this.commissionAgreements[this.id].agreement;
      }
      return {};
    },
    additionalDetails() {
      if (this.commissionAgreements && this.commissionAgreements[this.id]) {
        return this.commissionAgreements[this.id].additionalDetails;
      }
      return {};
    },
    canceling() {
      if (this.commissionAgreements && this.commissionAgreements[this.id]) {
        return this.commissionAgreements[this.id].cancel;
      }
      return {};
    },
    property() {
      if (this.commissionAgreements && this.commissionAgreements[this.id]) {
        if (this.commissionAgreements[this.id].property
          && !this.commissionAgreements[this.id].property.taloyhtio) {
          return { ...this.commissionAgreements[this.id].property, taloyhtio: {} };
        }
        return this.commissionAgreements[this.id].property;
      }
      return {};
    },
    signatures() {
      if (
        this.commissionAgreements
        && this.commissionAgreements[this.id]
        && this.commissionAgreements[this.id].signatures
      ) {
        return this.commissionAgreements[this.id].signatures;
      }
      return [];
    },
    identifiedUser() {
      if (this.commissionAgreements && this.commissionAgreements[this.id]) {
        return this.commissionAgreements[this.id].identifiedUser;
      }
      return {};
    },
    identifiedUserHasSigned() {
      if (this.commissionAgreements && this.commissionAgreements[this.id]) {
        return this.commissionAgreements[this.id].identifiedUserHasSigned;
      }
      return false;
    },
    oldVersion() {
      if (this.commissionAgreements && this.commissionAgreements[this.id]) {
        return moment(this.commissionAgreements[this.id].created, 'YYYY-MM-DD H:m:s') < moment('2020-06-10 10:00:00', 'YYYY-MM-DD H:m:s');
      }
      return false;
    },
    sellersPreview() {
      return this.property?.sellers?.filter(s => ![5, 6].includes(+s.rooli));
    },
    signingSellers() {
      const filteredSigningSellers = this.property?.sellers
        ?.filter(s => ![4, 6].includes(+s.rooli));

      if (filteredSigningSellers?.length > 0) {
        return filteredSigningSellers;
      }

      return [{}, {}];
    },
    sellers() {
      if (this.sellersPreview?.length > 0) {
        if (this.sellersPreview.length === 1) {
          return [
            this.sellersPreview[0],
            {},
          ];
        }
        return this.sellersPreview;
      }
      return [
        {},
        {},
      ];
    },
  },
  async mounted() {
    const parameters = {};
    if (this.side) {
      parameters.side = this.side;
    }
    await this.getAgreement({ id: this.id, parameters });
    this.loading = false;
    if (this.agent) {
      this.setSellersForSending();
      await this.setCurrentProperty(this.id);
      await this.getLog();
      this.showChangeDialog = await this.detectChanges();
    }

    const getClauses = () => import(`./commissionAgreement/data/clauses.${this.type}.js`);
    const { default: clauses } = await getClauses();
    this.clauses = clauses;
  },
  methods: {
    ...mapActions({
      setCurrentProperty: 'setCurrentProperty',
      setCompanyName: 'setCompanyName',
      getProperty: 'properties/getOne',
      getAgreement: 'commissionAgreement/getOne',
    }),

    setSellersForSending() {
      this.sellersForSending = _.cloneDeep(this.signingSellers);
      this.sellersForSending = this.sellersForSending?.map((s) => {
        if (this.signatures.some(sig => +sig.person_id === +s.henkilo_id)) {
          return { ...s };
        }
        return { ...s, send: true };
      });
    },

    async logout() {
      await apiGet('authorization/logout');
      const parameters = {};
      if (this.side) {
        parameters.side = this.side;
      }
      await this.getAgreement({ id: this.id, parameters });
    },

    async openSendLinksDialog() {
      const changesDetected = await this.detectChanges();
      if (changesDetected) {
        this.showChangeDialog = true;
      } else {
        this.sendLinksDialog = true;
      }
    },

    async detectChanges() {
      if (this.signatures && this.signatures.length > 0) {
        return false;
      }
      const currentProperty = await this.getProperty({ id: this.id });
      if (currentProperty.muokattu !== this.property.muokattu) {
        return true;
      }
      return false;
    },
    goBack() {
      this.$router.push({ name: 'commissionAgreement', params: this.$route.params });
    },
    async sendLinks() {
      this.sendLinksDialog = false;
      const persons = this.sellersForSending?.filter(s => s.send);
      await apiPost('commission-agreement/link', { id: this.id, side: this.side, persons });
      await this.getLog();
      this.message = 'Allekirjoituslinkit lähetetty';
      this.messageColor = 'green';
      this.messageBox = true;
    },
    async getLog() {
      let side = '/all';
      if (this.side) {
        side = `/${this.side}`;
      }
      const logresponse = await apiGet(`commission-agreement/log/${this.id}${side}`);
      this.logItems = logresponse.result;
    },
    async sign() {
      this.signDialog = false;
      await apiPost('commission-agreement/sign', {});
      const parameters = {};
      if (this.side) {
        parameters.side = this.side;
      }
      await this.getAgreement({ id: this.id, parameters });
    },
    checkBox(checked = ' ', title, span = 1, bottomBorder = true, noBorders = false, small = false, rowSpan = 1) { // eslint-disable-line
      const box = {
        table: {
          widths: [small ? 4 : 8],
          body: [
            [
              {
                text: checked,
                fontSize: small ? 6 : 8,
                margin: [0.5, 0.5, 0, 0],
                border: [noBorders, noBorders, true, true],
              },
            ],
          ],
        },
        border: [false, false, false, false],
        layout: {
          hLineColor: () => '#888888',
          vLineColor: () => '#888888',
          hLineWidth: () => 0.2,
          vLineWidth: () => 0.2,
        },
        margin: [-4, -2, 0, 0],
      };

      const checkbox = {
        table: {
          widths: [small ? 4 : 8, '*'],
          body: [
            [
              box,
              {
                text: title,
                fontSize: small ? 7 : 9,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                color: '#666666',
              },
            ],
          ],
        },
        margin: [-4, -2, 0, 5],
        colSpan: span,
        rowSpan,
        border: [!noBorders, !noBorders, !noBorders, bottomBorder],
        layout: {
          hLineColor: () => '#888888',
          vLineColor: () => '#888888',
          hLineWidth: () => 0.2,
          vLineWidth: () => 0.2,
        },
      };

      return checkbox;
    },
    pdfTable(title, value, colSpan, rowSpan = 1, fontSize = 9) {
      return {
        unbreakable: true,
        table: {
          widths: ['*'],
          body: [
            [{
              text: title,
              fontSize: 7,
              margin: [0, 0, 0, 0],
              color: '#666666',
            }],
            [{ text: value, fontSize, margin: [0, -3, 0, 0] }],
          ],
        },
        rowSpan,
        colSpan,
        layout: 'noBorders',
        margin: [0, -2, 0, -2],
      };
    },
    title(title) {
      return {
        text: title,
        margin: [0, 8, 0, 2],
        fontSize: 8.5,
        color: '#777777',
      };
    },
    async printPdfWrapper() {
      const changesDetected = await this.detectChanges();
      if (changesDetected) {
        this.showChangeDialog = true;
      } else {
        this.printPdf();
      }
    },
    printPdf() {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf',
        },
        Icons: {
          normal: 'Icons.ttf',
        },
      };
      const line = '#888888';
      const greyBorders = () => ({
        hLineColor: () => line,
        vLineColor: () => line,
        hLineWidth: () => 0.2,
        vLineWidth: () => 0.2,
      });
      const content = [];
      const wideFields = [
        'Katuosoite',
        'Huonekuvaus',
        'Muu hallintaperuste',
        'Tontin vuokranantaja',
        // 'Lisätietoja pinta-aloista',
      ];

      const textNoBorders = {
        text: ' ',
        border: [false, false, false, false],
      };
      let row = [textNoBorders, textNoBorders];
      let i = 0;
      let order = 1;
      // COVER
      if (this.logo !== false && this.logo !== null) {
        content.push({
          image: this.logo, width: 300, alignment: 'center', margin: [0, 180, 0, 20],
        });
      }
      content.push({
        text: this.side === 'additional' ? 'SELOSTUSLIITE' : this.mainTitle, fontSize: 30, alignment: 'center',
      });
      content.push({
        text: `${this.assignmentTitle}`, fontSize: 20, alignment: 'center', color: '#777777',
      });
      let address = this.property.kohdenimi;
      if (this.osake) {
        address = `${address} ${this.property.huoneistonro}`;
      }
      if (this.property.postinumero !== '') {
        address = `${address}, ${this.property.postinumero} ${this.property.kaupunki}`;
      }
      content.push({
        text: `\n${address}`, fontSize: 14, alignment: 'center', pageBreak: 'after',
      });
      // PRIVACY POLICY
      content.push({
        columns: [
          {
            color: '#666666',
            text: [
              { text: 'TIETOSUOJASELOSTE', fontSize: 7 },
              '\n\nTietosuojalain ja Euroopan Unionin yleisen tietosuoja-asetuksen (2016/679/EU) mukainen yhdistetty tietosuojaseloste ja informointiasiakirja.\n\n',
              { text: `1. REKISTERINPITÄJÄ\n${this.property.companyName}\n${this.property.companyAddress}\nY-tunnus: ${this.property.companyVat}` },
              '\n\n2. HENKILÖTIETOJEN KÄSITTELIJÄ\nRMR Holding Oy / Helmi-kiinteistönvälitysjärjestelmä\nKauppakatu 7\n26100 Rauma\ny-tunnus: 2402115-6',
              '\n\n3. YHTEYDENOTTO TIETOSUOJA-ASIOISSA\ntekniikka@rmr.fi\n\n',
              this.clauses.privacyPolicy,
            ],
            fontSize: 5.5,
            width: '50%',
            margin: [13, 10, 2, 0],
          }, {
            color: '#666666',
            text: this.clauses.privacyPolicy2,
            fontSize: 5.5,
            width: '50%',
            margin: [2, 10, 13, 0],
          },
        ],
        pageBreak: 'after',
      });

      let agentSign;
      let signatureTable;
      /**
       * AGREEMENT PDF STARTS
       */
      if (!this.side || this.side === 'agreement') {
        if (this.logo !== false && this.logo !== null) {
          content.push({
            image: this.logo, fit: [160, 50], width: 160, height: 50, margin: [0, 17, 0, 11],
          });
        }
        const topTitle = `${this.mainTitle}SOPIMUS`;
        content.push({ text: [topTitle, { text: '   |   ', color: '#777777', fontSize: 13 }, this.assignmentTitle.toUpperCase()], fontSize: 11 });

        content.push(this.title('1 KOHDE'));

        const propertyTable = {
          table: {
            widths: ['75%', '*'],
            body: [
              [
                this.pdfTable('1.1 Osoite', address || ' ', 1),
                this.pdfTable('1.2 Toimeksiantonumero', this.property.kohdenumero || ' ', 1),
              ],
            ],
          },
          layout: greyBorders(),
        };
        content.push(propertyTable);

        // sellers
        const sellersTable = {
          table: {
            widths: [150, 200, '*', '*'],
            body: [],
          },
          layout: greyBorders(),
        };

        order = 1;

        this.sellers.forEach((seller) => {
          row = [
            this.pdfTable(`2.${order} Nimi`, seller.nimi || ' ', 1),
            this.pdfTable(`2.${order}.1 Henkilötunnus / Y-tunnus`, seller.sotu || ' ', 1),
            this.pdfTable(`2.${order}.2 Sähköposti`, seller.email || ' ', 2),
            ' ',
          ];
          sellersTable.table.body.push(row);
          row = [
            this.pdfTable(`2.${order}.3 Puhelin`, seller.puhelin || ' ', 1),
            this.pdfTable(`2.${order}.4 Osoite`, seller.osoite || ' ', 1),
            this.pdfTable(`2.${order}.5 Postinumero`, seller.postinumero || ' ', 1),
            this.pdfTable(`2.${order}.6 Kaupunki`, seller.kaupunki || ' ', 1),
          ];
          sellersTable.table.body.push(row);
          order += 1;
        });

        content.push(this.title('2 TOIMEKSIANTAJAT'));
        content.push(sellersTable);

        // company
        const companyTable = {
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                this.pdfTable('3.1 Välitysliike', this.property.companyName || ' ', 1),
                this.pdfTable('3.2 Y-tunnus', this.property.companyVat || ' ', 1),
                this.pdfTable('3.3 Osoite', this.property.companyAddress || ' ', 1),
              ],
              [
                this.pdfTable('3.4 Asiaa hoitava henkilö', this.property.agentName || ' ', 1),
                this.pdfTable('3.5 Puhelin', this.property.agentPhone || ' ', 1),
                this.pdfTable('3.6 Sähköposti', this.property.agentEmail || ' ', 1),
              ],
            ],
          },
          layout: greyBorders(),
        };
        content.push(this.title('3 VÄLITYSLIIKE'));
        content.push(companyTable);

        content.push(this.title('4 TOIMEKSIANNON EHDOT'));
        if (!this.rent) {
          content.push({
            text: [
              { text: `Toimeksiantaja antaa ${this.property.companyName} -välitysliikkeelle yksinoikeudella välitettäväksi (jollei kohdassa 10.9 ole muuta sovittu) tämän sopimuksen liitteessä yksilöidyn omaisuuden jäljempänä mainituilla ehdoilla. Välitysliike on oikeutettu yksinomaan välittämään kohdetta tässä sopimuksessa ja sen liitteessä yksilöidyssä kunnossa ja varustein.\n\nVälitysliikkeen tehtävänä on:\n` },
              ' • arvioida asunto-osakkeen todennäköinen velaton kauppahinta kauppahintatilastojen ja/tai markkinatietämyksensä perusteella, sekä ilmoittaa niissä tapahtuvista muutoksista toimeksiantosuhteen aikana\n',
              ' • ilmoittaa asunto-osakkeen velattoman kauppahinnan arvioinnin perusteet\n',
              ' • laatia kohteen myyntimateriaali toimeksiantajan tässä sopimuksessa ja sen liitteissä antamien tietojen sekä kohdassa 10.2 mainitun selonottovelvollisuutensa perusteella hankittavien tietojen pohjalta ja esittää myyntiesite toimeksiantajalle ennen markkinoinnin aloittamista\n',
              ' • järjestää myyntiesittelyt\n',
              ' • avustaa tarjousasiakirjojen laatimisessa ja esittää tarjoukset osapuolille\n',
              ' • kertoa sekä toimeksiantajalle että ostotarjouksen tekijälle tarjoukseen ja sen hyväksymiseen sekä mahdolliseen ehdollisuuteen liittyvistä kysymyksistä ottaen huomioon molempien osapuolten edut\n',
              ' • laatia kauppakirja ja varainsiirtoverolaskelma\n',
              ' • huolehtia kaupan käytännön järjestelyistä.',
            ],
            fontSize: 7,
            color: '#777777',
          });
        } else {
          content.push({
            text: [
              ' • 4.1 Toimeksiantaja antaa välitysliikkeelle tässä toimeksiantosopimuksessa mainitun kohteen yksinoikeudella vuokrattavaksi tässä toimeksiantosopimuksessa ja sen liitteenä olevassa selostusliitteessä mainituin tai myöhemmin erikseen sovittavin ehdoin. Toimeksiantaja valtuuttaa välitysliikkeen hankkimaan ja saamaan kaikki tarvittavat tiedot ja asiakirjat vuokrauskohteesta. Toimeksiantaja vakuuttaa antaneensa kaikki ne tiedot huoneistosta, joilla saattaa olla vaikutusta vuokralaisen päätökseen. Toimeksiantaja vakuuttaa olevansa oikeutettu vuokraamaan huoneiston tarvitsematta siihen lupaa tai suostumusta keneltäkään muulta kuin mahdolliselta puolisoltaan. Mikäli toimeksiantaja haluaa välitysliikkeen ilmoituskäytännöstä poikkeavia ilmoituksia tai muita mainoksia, sitoutuu hän korvaamaan tästä aiheutuneet kulut.\n\n',
              ' • 4.2 Välitysliike arvioi vuokran määrän, laatii esitteen, huolehtii kohteen markkinoinnista ja esittelystä, vasta vuokratarjousten vastaanottamisesta ja vuokralaisten luottotietojen tarkistamisesta sekä laatii vuokrasopimuksen vuokranantajan ja vuokralaisen hyväksymien ehtojen mukaisesti, ellei muuta ole sovittu.',
            ],
            fontSize: 8,
            color: '#777777',
          });
        }

        // agreement
        const agreementKeys = Object.keys(this.agreement);
        agreementKeys.forEach((detail) => {
          const agreementChildrenKeys = Object.keys(this.agreement[detail]?.children);
          const agreementTable = {
            table: {
              dontBreakRows: true,
              widths: ['*', '*'],
              body: [],
            },
            layout: greyBorders(),
          };
          const addClauseToAgreement = (clause) => {
            if (this.rent && clause === 'marketingAndAqcuisitionFee') {
              console.warn('skip marketing and aqcuisition clause');
            } else {
              row[0] = {
                text: `${this.clauses[clause]}`,
                fontSize: 6,
                color: '#777777',
                colSpan: 2,
                border: [false, false, false, false],
                margin: [0, 0, 0, 2],
              };
              row[1] = ' ';
              agreementTable.table.body.push(row);
              i = 0;
              row = [textNoBorders, textNoBorders];
            }
          };
          i = 0;
          order = 1;
          row = [textNoBorders, textNoBorders];
          agreementChildrenKeys.forEach((key) => {
            let colSpan = 1;
            const wide = [
              'estimatedSalesPeriod',
              'sellingPointsAndWeaknesses',
              'releaseDate',
              'additionalInfoLease',
              'typeOfAgreement',
              'untilFurtherNoticeTitle',
              'marketingAndAqcuisitionFee',
              'permanentHousing',
              'legalPartition',
              'clientHasBeenInformedOfTaxes',
              'capitalGainsTax',
              'directClientToTaxAdministration',
              'inOfficeCommitment',
              'outOfOfficeCommitment',
              'clientHasRecievedCancellationFormAndInstructions',
              'startBeforeCancellationTimeExpires',
              'privacyPolicyAvailability',
              'dataHandlingAgreement',
              'marketingAgreement',
              'identificationInformationSharingAgreement',
              'unencryptedEmailAwareness',
              'PEPStatus',
              'PEPAdditionalInfo',
              'asuntojenHintatiedotAcceptance',
              'otherTerms',
              'otherRentalTerms',
              'rentIncreaseOther',
              'rentIncrease',
              'releaseDate_1',
              'otherExpenses',
              'rentalTimeMoreInfo',
            ];
            colSpan = wide.includes(key) ? 2 : 1;
            if (colSpan === 2 && i === 1) {
              row[0].colSpan = 2;
              row[1].colSpan = ' ';
              agreementTable.table.body.push(row);
              row = [textNoBorders, textNoBorders];
              i = 0;
            }
            const clauses = [
              'responsibility_1',
              'responsibility_2',
              'responsibility_3',
              'responsibility_4',
              'responsibility_5',
              'responsibility_6',
              'privacyClause',
            ];
            if (this.agreement[detail]?.children[key].component === 'helmi-subheader') {
              console.warn('subheader');
            } else if (clauses.includes(key)) {
              order += 1;
              colSpan = 2;

              const clauseTable = {
                table: {
                  dontBreakRows: true,
                  unbreakable: true,
                  widths: ['*'],
                  body: [],
                },
                layout: 'noBorders',
                border: [false, false, false, false],
                margin: [0, 0, 0, 0],
                colSpan: 2,
              };

              if (this.agreement[detail]?.children[key].props.label) {
                clauseTable.table.body.push([{
                  ...this.title(`${this.agreement[detail]?.children[key].chapter} ${this.agreement[detail]?.children[key].props.label.toUpperCase()}`),
                  border: [false, false, false, false],
                  margin: [0, 0, 0, 0],
                }]);
              }
              clauseTable.table.body.push([{
                text: this.agreement[detail]?.children[key].props.hint,
                fontSize: 6.5,
                margin: [0, -4, 0, 4],
                color: '#777777',
                border: [false, false, false, false],
              }]);
              agreementTable.table.body.push([clauseTable, ' ']);
              i = 0;
              row = [textNoBorders, textNoBorders];
            } else if (this.agreement[detail]?.children[key].component === 'helmi-title') {
              order += 1;
              colSpan = 2;

              if (key === 'untilFurtherNoticeTitle') {
                row[0] = {
                  text: `${this.agreement[detail]?.children[key].chapter} ${this.agreement[detail]?.children[key].props.label}`,
                  fontSize: 7,
                  color: '#777777',
                  colSpan,
                  border: [false, false, false, false],
                };
              } else if (key === 'permanentResidence') {
                row[0] = {
                  ...this.title(`${this.agreement[detail]?.children[key].component === 'helmi-title' ? `${this.agreement[detail]?.children[key].chapter} ` : ''}${this.agreement[detail]?.children[key].props.label}`),
                  colSpan,
                  fontSize: 7,
                  color: '#777777',
                  border: [false, false, false, false],
                };
              } else {
                row[0] = {
                  ...this.title(`${this.agreement[detail]?.children[key].component === 'helmi-title' ? `${this.agreement[detail]?.children[key].chapter} ` : ''}${this.agreement[detail]?.children[key].props.label.toUpperCase()}`),
                  colSpan,
                  border: [false, false, false, false],
                };
              }
              row[1] = ' ';
              agreementTable.table.body.push(row);
              i = 0;
              row = [textNoBorders, textNoBorders];

              if (Object.keys(this.clauses).includes(key)) {
                addClauseToAgreement(key);
              }
            } else {
              if (this.agreement[detail]?.children[key].component === 'helmi-radiogroup') {
                let cSpan = 2;
                if (key === 'paymentTerm') {
                  cSpan = 1;
                }
                const radioGroup = {
                  table: {
                    dontBreakRows: true,
                    widths: ['*', '*'],
                    body: [],
                  },
                  layout: 'noBorders',
                  colSpan: cSpan,
                };

                const radiorow = [
                  { ...this.checkBox(this.agreement[detail]?.children[key].value === this.agreement[detail]?.children[key].options[0] ? 'X' : ' ', this.agreement[detail]?.children[key].options[0], 1, true, true, true), margin: [1, 0, 0, 0] },
                  { ...this.checkBox(this.agreement[detail]?.children[key].value === this.agreement[detail]?.children[key].options[1] ? 'X' : ' ', this.agreement[detail]?.children[key].options[1], 1, true, true, true), margin: [1, 0, 0, 0] },
                ];
                const labelrow = [
                  {
                    text: `${this.agreement[detail]?.children[key].chapter} ${this.agreement[detail]?.children[key].props.label}`,
                    colSpan: 2,
                    fontSize: 7,
                    margin: [0, 0, 0, 0],
                    color: '#666666',
                  },
                  ' ',
                ];
                if (this.agreement[detail]?.children[key].options.length > 2) {
                  radioGroup.table.widths = ['*', '*', '*'];
                  radiorow[2] = { ...this.checkBox(this.agreement[detail]?.children[key].value === this.agreement[detail]?.children[key].options[2] ? 'X' : ' ', this.agreement[detail]?.children[key].options[2], 1, true, true, true), margin: [1, 0, 0, 0] };
                  labelrow[0].colSpan = 3;
                  labelrow[2] = ' ';
                }
                radioGroup.table.body.push(labelrow);
                radioGroup.table.body.push(radiorow);
                row[i] = radioGroup;
                if (key !== 'paymentTerm') {
                  i += 1;
                }
              } else if (this.agreement[detail]?.children[key].component === 'helmi-checkbox') {
                row[i] = this.checkBox(this.agreement[detail]?.children[key].value === 'Kyllä' ? 'X' : ' ', `${this.agreement[detail]?.children[key].chapter} ${this.agreement[detail]?.children[key].props.label}`, colSpan, true, false, true);
              } else {
                let value = ' ';
                if (this.agreement[detail]?.children[key].value) {
                  if (this.agreement[detail]?.children[key].component === 'helmi-date-picker') {
                    value = this.$options.filters.date(this.agreement[detail]?.children[key].value);
                  } else if (this.agreement[detail]?.children[key].props.type === 'number') {
                    value = this.$options.filters.currency(this.agreement[detail]?.children[key].value, { style: 'decimal' });
                    value = `${value} ${this.agreement[detail]?.children[key].props.suffix}`;
                  } else {
                    ({ value } = this.agreement[detail]?.children[key]);
                  }
                }
                row[i] = this.pdfTable(`${this.agreement[detail]?.children[key].chapter} ${this.agreement[detail]?.children[key].props.label}`, value, colSpan);
              }
              order += 1;
              i += colSpan;
              if (i < 2) {
                if (
                  agreementChildrenKeys
                    .indexOf(key) === agreementChildrenKeys.length - 1
                ) {
                  agreementTable.table.body.push(row);
                  if (Object.keys(this.clauses).includes(key)) {
                    addClauseToAgreement(key);
                  }
                }
              } else {
                agreementTable.table.body.push(row);
                i = 0;
                row = [textNoBorders, textNoBorders];
                if (Object.keys(this.clauses).includes(key)) {
                  addClauseToAgreement(key);
                }
              }
            }
          });
          content.push(this.title(`${this.agreement[detail].chapter} ${this.agreement[detail].props.label.toUpperCase()}`));
          content.push(agreementTable);
        });

        let addOrder = 13;
        content.push(this.title(`${addOrder} ALLEKIRJOITUKSET`));
        signatureTable = {
          table: {
            dontBreakRows: true,
            unbreakable: true,
            widths: ['*'],
            body: [],
          },
          margin: [0, 0, 0, 0],
          layout: greyBorders(),
        };

        order = 1;
        this.signingSellers.forEach((seller) => {
          const chunk = (str, n) => {
            const ret = [];
            let idx;
            let len;

            for (idx = 0, len = str.length; idx < len; idx += n) {
              ret.push(str.substr(idx, n));
            }

            return ret;
          };

          const signature = this.signatures.find(signer => +signer.person_id === +seller.henkilo_id);
          const identification = [
            {
              table: {
                widths: ['*', 65, 75, 55, '*', '*'],
                body: [
                  [
                    {
                      text: `${addOrder}.${order}.${signature ? '3' : '2'} Tunnistus`,
                      fontSize: 6,
                      margin: [0, 0, 0, 0],
                      color: '#777777',
                    },
                    this.checkBox(' ', 'Ajokortti', 1, true, true, true),
                    this.checkBox(' ', 'Henkilökortti', 1, true, true, true),
                    this.checkBox(' ', 'Passi', 1, true, true, true),
                    this.checkBox(' ', 'Kuvallinen henkilökortti', 1, true, true, true),
                    this.checkBox(signature ? 'X' : ' ', 'Sähköinen tunnistautuminen', 1, true, true, true),
                  ],
                ],
              },
              margin: [0, 3, 0, -5],
              layout: 'noBorders',
            },
          ];
          let sellerRow = ' ';
          if (signature) {
            sellerRow = [this.pdfTable(`${addOrder}.${order} Allekirjoitus ja nimenselvennys`, `${signature.name} - Allekirjoitettu sähköisesti`, 1)];
            signatureTable.table.body.push(sellerRow);
            signatureTable.table.body.push([this.pdfTable(`${addOrder}.${order}.1 Paikka ja aika`, `${this.$options.filters.date(signature.created)} klo ${this.$options.filters.date(signature.created, { type: 'time' })}`)]);
            const signatureRow = [this.pdfTable(`${addOrder}.${order}.2 Sähköinen tunniste`, chunk(signature.signature, 135).join('\n'), 1, 1, 7)];
            signatureTable.table.body.push(signatureRow);
          } else {
            sellerRow = [this.pdfTable(`${addOrder}.${order} Allekirjoitus ja nimenselvennys`, `${seller.nimi ? seller.nimi : ' '}`, 1)];
            signatureTable.table.body.push(sellerRow);
            signatureTable.table.body.push([this.pdfTable(`${addOrder}.${order}.1 Paikka ja aika`, ' ')]);
          }
          signatureTable.table.body.push(identification);

          order += 1;
        });

        if (signatureTable.table.body.length > 0) {
          content.push(signatureTable);
        }

        addOrder += 1;
        order = 1;
        agentSign = {
          table: {
            widths: ['*'],
            body: [
              [
                this.pdfTable(`${addOrder}.${order} Välittäjän allekirjoitus`, `${this.property.agentName} - Allekirjoitettu sähköisesti` || ' ', 1),
              ],
            ],
          },
          layout: greyBorders(),
        };
        if (!this.oldVersion) {
          content.push(this.title(`${addOrder} VÄLITYSLIIKKEEN ALLEKIRJOITUKSET`));
          content.push(agentSign);
        }
      }

      /**
       * ADDITIONAL DETAILS PDF STARTS
       */
      if (!this.side || this.side === 'additional') {
        const checkboxes = [
          'Yhtiö perustettu ennen 1.1.1992',
          'Pinta-ala isännöitsijäntodistuksen mukainen',
          'Pinta-ala yhtiöjärjestyksen mukainen',
          'Pinta-ala toimeksiantajan ilmoittama',
          'Pinta-ala tarkistusmitattu',
          'Yhtiöjärjestyksen mukainen hallintaperuste',
          'Uudiskohde',
          'Tarjouskauppa',
        ];
        // Assignment details
        const assignmentKeys = Object.keys(this.assignment);
        const assignmentTable = {
          table: {
            dontBreakRows: true,
            widths: ['*', '*', '*'],
            body: [],
          },
          layout: greyBorders(),
        };
        if (this.side === 'additional' && this.logo !== false && this.logo !== null) {
          content.push({
            image: this.logo, fit: [160, 50], width: 160, height: 50, margin: [0, 0, 0, 10],
          });
        } else if (this.logo !== false && this.logo !== null) {
          content.push({
            image: this.logo, fit: [160, 50], width: 160, height: 50, margin: [0, 0, 0, 10], pageBreak: 'before',
          });
        }

        row = [textNoBorders, textNoBorders, textNoBorders];
        if (this.osake) {
          row = [textNoBorders, textNoBorders, textNoBorders, textNoBorders];
          assignmentTable.table.widths.push('*');
        }
        i = 0;
        order = 1;
        assignmentKeys.forEach((key) => {
          if (this.osake) {
            wideFields.push('Vapautuminen');
          }
          let colSpan = wideFields.includes(key) ? 2 : 1;
          if (checkboxes.includes(key)) {
            colSpan = 1;
            row[i] = this.checkBox(this.assignment[key] === 'Kyllä' ? 'X' : ' ', `1.${order} ${key}`, 1, true, false, true);
          } else {
            row[i] = this.pdfTable(`1.${order} ${key}`, this.assignment[key] || ' ', colSpan);
          }
          order += 1;
          if (i < (this.osake ? 3 : 2)) {
            i += colSpan;
            if (assignmentKeys.indexOf(key) === assignmentKeys.length - 1) {
              assignmentTable.table.body.push(row);
            }
          } else {
            assignmentTable.table.body.push(row);
            i = 0;
            row = [textNoBorders, textNoBorders, textNoBorders];
            if (this.osake) {
              row = [textNoBorders, textNoBorders, textNoBorders, textNoBorders];
            }
          }
        });

        content.push({ text: `${this.assignmentType.toUpperCase()} SELOSTUSLIITE`, pageBreak: !this.side ? 'before' : '' });
        content.push(this.title('1 TOIMEKSIANTO'));
        content.push(assignmentTable);

        // basic details
        const basicDetailsKeys = Object.keys(this.basicDetails);
        const basicDetailsTable = {
          table: {
            dontBreakRows: true,
            widths: ['*', '*', '*', '*'],
            body: [],
          },
          layout: greyBorders(),
        };
        i = 0;
        order = 1;
        row = [textNoBorders, textNoBorders, textNoBorders, textNoBorders];
        basicDetailsKeys.forEach((key) => {
          let colSpan = wideFields.includes(key) ? 3 : 1;
          if (key === 'Yhtiöjärjestyksen mukainen huoneistoselitelmä') {
            colSpan = 4;
          }
          if (!this.osake && (key === 'Lisätietoja pinta-aloista' || key === 'Ilmanvaihto' || key === 'Lämmitysjärjestelmä')) {
            colSpan = 2;
          }
          if (!this.osake && key === 'Kiinteistön lisätiedot') {
            colSpan = 4;
          }
          if (checkboxes.includes(key)) {
            colSpan = 1;
            row[i] = this.checkBox(this.basicDetails[key] === 'Kyllä' ? 'X' : ' ', `2.${order} ${key}`, 1, true, false, true);
          } else {
            row[i] = this.pdfTable(`2.${order} ${key}`, this.basicDetails[key] || ' ', colSpan);
          }
          order += 1;
          i += colSpan;
          if (i < 4) {
            if (basicDetailsKeys.indexOf(key) === basicDetailsKeys.length - 1) {
              basicDetailsTable.table.body.push(row);
            }
          } else {
            basicDetailsTable.table.body.push(row);
            i = 0;
            row = [textNoBorders, textNoBorders, textNoBorders, textNoBorders];
          }
        });
        content.push(this.title('2 PERUSTIEDOT'));
        content.push(basicDetailsTable);

        // basic details
        const priceAndExpencesKeys = Object.keys(this.priceAndExpences);
        const priceAndExpencesTable = {
          table: {
            dontBreakRows: true,
            widths: ['*', '*', '*'],
            body: [],
          },
          layout: greyBorders(),
        };
        i = 0;
        order = 1;
        row = [textNoBorders, textNoBorders, textNoBorders];
        priceAndExpencesKeys.forEach((key) => {
          let colSpan = wideFields.includes(key) ? 3 : 1;
          if (key === 'Energiankulutus' || key === 'Muut maksut') {
            if (i === 1) {
              row[0].colSpan = 3;
              priceAndExpencesTable.table.body.push(row);
              row = [textNoBorders, textNoBorders, textNoBorders];
              i = 0;
            } else if (i === 2) {
              row[1].colSpan = 2;
              row[2] = ' ';
              priceAndExpencesTable.table.body.push(row);
              row = [textNoBorders, textNoBorders, textNoBorders];
              i = 0;
            }
            colSpan = 3;
          }
          row[i] = this.pdfTable(`3.${order} ${key}`, this.priceAndExpences[key] || ' ', colSpan);
          order += 1;
          i += colSpan;
          if (i < 3) {
            if (priceAndExpencesKeys.indexOf(key) === priceAndExpencesKeys.length - 1) {
              priceAndExpencesTable.table.body.push(row);
            }
          } else {
            priceAndExpencesTable.table.body.push(row);
            i = 0;
            row = [textNoBorders, textNoBorders, textNoBorders];
          }
        });
        content.push(this.title('3 KUSTANNUKSET'));
        content.push(priceAndExpencesTable);

        // equipment details
        const equipmentKeys = Object.keys(this.equipment);
        const equipmentTable = {
          table: {
            dontBreakRows: true,
            widths: ['*', '*'],
            body: [],
          },
          layout: greyBorders(),
        };
        i = 0;
        order = 1;
        row = [textNoBorders, textNoBorders];
        equipmentKeys.forEach((key) => {
          let colSpan = 2;
          const narrow = [
            'Saunan lisätiedot',
            'Sauna',
            'Asunnossa on parveke',
            'Parvekkeen lisätiedot',
            'Keittiön lattia',
            'Keittiön seinät',
            'Kylpyhuoneen lattia',
            'Kylpyhuoneen seinät',
            'Makuuhuoneen lattia',
            'Makuuhuoneen seinät',
            'Olohuoneen lattia',
            'Olohuoneen seinät',
          ];
          if (narrow.includes(key)) {
            colSpan = 1;
          }
          row[i] = this.pdfTable(`4.${order} ${key}`, this.equipment[key] || (colSpan === 2 ? ' \n' : ' '), colSpan);
          order += 1;
          i += colSpan;
          if (i < 2) {
            if (equipmentKeys.indexOf(key) === equipmentKeys.length - 1) {
              equipmentTable.table.body.push(row);
            }
          } else {
            equipmentTable.table.body.push(row);
            i = 0;
            row = [textNoBorders, textNoBorders];
          }
        });
        if (this.osake) {
          const wrapper = {
            table: {
              dontBreakRows: true,
              widths: ['*', '*'],
              body: [
                [
                  {
                    text: `4.${order} Asukkaan käytössä olevien tilojen (esim autopaikka tai varastotilat) hallintaperuste`,
                    colSpan: 2,
                    fontSize: 7,
                    margin: [0, 0, 0, 0],
                    color: '#666666',
                  },
                  ' ',
                ],
                [
                  {
                    ...this.checkBox(this.additionalDetails
                      .apartmentManagementCriterionOccupant?.children
                      .articlesOfAssociationOccupant.value === 'Kyllä' ? 'X' : ' ',
                    `4.${order}.1 Yhtiöjärjestyksen mukainen`, 1, true, true, true),
                    margin: [1, 0, 0, 0],
                  },
                  this.pdfTable(`4.${order}.2 Muu hallintaperuste`, this.additionalDetails
                    .apartmentManagementCriterionOccupant?.children
                    .apartmentManagementCriterionOccupantOther.value || ' ', 1),
                ],
              ],
            },
            layout: 'noBorders',
            colSpan: 2,
          };
          equipmentTable.table.body.push([wrapper, ' ']);
        }
        content.push(this.title('4 TILOJEN VARUSTUS'));
        content.push(equipmentTable);

        // Housing company
        if (this.osake) {
          const housingCompanyKeys = Object.keys(this.housingCompany);
          const housingCompanyTable = {
            table: {
              dontBreakRows: true,
              widths: ['*', '*', '*'],
              body: [],
            },
            layout: greyBorders(),
          };
          i = 0;
          order = 1;
          row = [textNoBorders, textNoBorders, textNoBorders];
          housingCompanyKeys.forEach((key) => {
            let colSpan = 1;
            if (key === 'Taloyhtiön nimi') {
              if (i === 1) {
                row[0].colSpan = 3;
                housingCompanyTable.table.body.push(row);
                row = [textNoBorders, textNoBorders, textNoBorders];
                i = 0;
              } else if (i === 2) {
                row[1].colSpan = 2;
                row[2] = ' ';
                housingCompanyTable.table.body.push(row);
                row = [textNoBorders, textNoBorders, textNoBorders];
                i = 0;
              }
              colSpan = 2;
            }
            const wide = ['Tehdyt korjaukset', 'Tulevat korjaukset', 'Isännöitsijätoimisto'];
            if (wide.includes(key)) {
              if (i === 1) {
                row[0].colSpan = 3;
                housingCompanyTable.table.body.push(row);
                row = [textNoBorders, textNoBorders, textNoBorders];
                i = 0;
              } else if (i === 2) {
                row[1].colSpan = 2;
                row[2] = ' ';
                housingCompanyTable.table.body.push(row);
                row = [textNoBorders, textNoBorders, textNoBorders];
                i = 0;
              }
              colSpan = 3;
            }
            row[i] = this.pdfTable(`5.${order} ${key}`, this.housingCompany[key] || ' ', colSpan);
            order += 1;
            i += colSpan;
            if (i < 3) {
              if (housingCompanyKeys.indexOf(key) === housingCompanyKeys.length - 1) {
                housingCompanyTable.table.body.push(row);
              }
            } else {
              housingCompanyTable.table.body.push(row);
              i = 0;
              row = [textNoBorders, textNoBorders, textNoBorders];
            }
          });
          content.push(this.title('5 TALOYHTIÖ JA ISÄNNÖITSIJÄ'));
          content.push(housingCompanyTable);
        }

        let addOrder;
        // additional details
        if (this.osake) {
          addOrder = 6;
        } else {
          addOrder = 6;
        }
        const additionalDetailsKeys = Object.keys(this.additionalDetails)
          ?.filter(key => !this.removedFields.includes(key));
        additionalDetailsKeys.forEach((detail) => {
          const additionalDetailsChildrenKeys = Object
            .keys(this.additionalDetails[detail]?.children || {});
          const additionalDetailsTable = {
            table: {
              dontBreakRows: true,
              widths: ['*', '*'],
              body: [],
            },
            layout: greyBorders(),
          };
          i = 0;
          order = 1;
          row = [textNoBorders, textNoBorders];
          additionalDetailsChildrenKeys.forEach((key) => {
            let colSpan = 1;
            const wide = [
              'Yhtiö perustettu ennen 1.1.1992',
              'Korjauksista / remonteista yhtiökokouksen päätös',
              'Muutostöistä ilmoitettu taloyhtiölle/isännöitsijälle',
              'Muut käyttö tai luovutusrajoitukset',
              'Suoritettu kosteusmittaus / kuntotarkastus',
              'PTS',
              'Rakennuksessa havaitut puutteet ja tiedossa olevat korjaukset',
              'Lisätietoja vioista ja puutteista',
              'Muuta kauppaan kuuluvaa',
              'Kauppaan ei kuulu',
              'Osakekirja on pantattu',
              'Osakekirjan säilytyspaikka',
              'Avaimet tilattava isännöitsijän kautta',
              'Muut kaupan kannalta merkittävät tiedot ja lisätiedot',
              'Lisätiedot',
              'Toimeksiantajan/aiempien omistajien kohteeseen teettämät/tekemät korjaukset/remontit ja muutostyöt, sekä niiden ajankohta ja korjauksen laajuus',
              'Onko rakennusvavontaviranomaiselta haettu / saatu lupa',
              'Kenelle lainhuuto myönnetty / Vuokraoikeus kirjattu',
              'Vesiosuuskunnan osakas',
              'Rannan edessä vesijättöä',
              'Käyttö- ja huolto-ohjeet',
              'Kohteen tai sen naapurikiinteistöjen tai lähialueen suunnitelmat, viranomaismenettelyt tai vastaavat',
              'Muut rakennukset (esim. ulkovarasto, autotalli)',
              'Lämmitysjärjestelmän kunto ja lisätiedot',
              'Asumisviihtyvyyteen vaikuttavat tekijät (esim. melu, haju, tärinä, kuumuus, kylmyys, veto, tuhoeläimet, jyrsijät)',
              'Toimeksiantajaa kehoitettu hankkimaan lain vaatima energiatodistus',
              'Toimeksiantaja on ilmoittanut kaikki sellaiset kiinteistöön kohdistuvat maksamattomat maksut, rasitukset, rasitteet sekä hallinnanrajoitukset, jotka eivät ilmene lainhuuto-, kiinnitys- ja kiinteistörekisteristä.',
              'Lisätietoa (maksut, rasitteet ja rasitukset)',
              'Liitteet',
            ];
            colSpan = wide
              .includes(this.additionalDetails[detail].children[key].props.label) ? 2 : 1;
            if (colSpan === 2 && i === 1) {
              row[0].colSpan = 2;
              row[1].colSpan = ' ';
              additionalDetailsTable.table.body.push(row);
              row = [textNoBorders, textNoBorders];
              i = 0;
            }
            if (this.additionalDetails[detail].children[key].component === 'helmi-subheader') {
              console.warn('subheader');
            } else if (this.additionalDetails[detail].children[key].component === 'helmi-title') {
              colSpan = 2;

              row[0] = {
                ...this.title(`${addOrder}.${order} ${this.additionalDetails[detail].children[key].props.label.toUpperCase()}`),
                colSpan,
                border: [false, false, false, false],
              };
              row[1] = ' ';
              additionalDetailsTable.table.body.push(row);
              i = 0;
              row = [textNoBorders, textNoBorders];
              order += 1;
            } else {
              if (this.additionalDetails[detail].children[key].component === 'helmi-radiogroup') {
                const radioGroup = {
                  table: {
                    dontBreakRows: true,
                    widths: ['*', '*'],
                    body: [],
                  },
                  layout: 'noBorders',
                  colSpan: 2,
                };
                const radiorow = [
                  { ...this.checkBox(this.additionalDetails[detail].children[key].value === this.additionalDetails[detail].children[key].options[0] ? 'X' : ' ', this.additionalDetails[detail].children[key].options[0], 1, true, true, true), margin: [1, 0, 0, 0] },
                  { ...this.checkBox(this.additionalDetails[detail].children[key].value === this.additionalDetails[detail].children[key].options[1] ? 'X' : ' ', this.additionalDetails[detail].children[key].options[1], 1, true, true, true), margin: [1, 0, 0, 0] },
                ];
                const labelrow = [
                  {
                    text: `${addOrder}.${order} ${this.additionalDetails[detail].children[key].props.label}`,
                    colSpan: 2,
                    fontSize: 7,
                    margin: [0, 0, 0, 0],
                    color: '#666666',
                  },
                  ' ',
                ];
                if (this.additionalDetails[detail].children[key].options.length > 2) {
                  radioGroup.table.widths = ['*', '*', '*'];
                  radiorow[2] = { ...this.checkBox(this.additionalDetails[detail].children[key].value === this.additionalDetails[detail].children[key].options[2] ? 'X' : ' ', this.additionalDetails[detail].children[key].options[2], 1, true, true, true), margin: [1, 0, 0, 0] };
                  labelrow[0].colSpan = 3;
                  labelrow[2] = ' ';
                }
                radioGroup.table.body.push(labelrow);
                radioGroup.table.body.push(radiorow);
                row[i] = radioGroup;
                i += 2;
              } else if (this.additionalDetails[detail].children[key].component === 'helmi-checkbox') {
                row[i] = this.checkBox(this.additionalDetails[detail].children[key].value === 'Kyllä' ? 'X' : ' ', `${addOrder}.${order} ${this.additionalDetails[detail].children[key].props.label}`, colSpan, true, false, true);
              } else {
                let value = (colSpan === 2 ? ' \n' : ' ');
                if (this.additionalDetails[detail].children[key].value) {
                  value = this.additionalDetails[detail].children[key].component === 'helmi-date-picker' ? this.$options.filters.date(this.additionalDetails[detail].children[key].value) : this.additionalDetails[detail].children[key].value;
                }
                row[i] = this.pdfTable(`${addOrder}.${order} ${this.additionalDetails[detail].children[key].props.label}`, value, colSpan);
              }
              order += 1;
              i += colSpan;
              if (i < 2) {
                if (
                  additionalDetailsChildrenKeys
                    .indexOf(key) === additionalDetailsChildrenKeys.length - 1
                ) {
                  additionalDetailsTable.table.body.push(row);
                }
              } else {
                additionalDetailsTable.table.body.push(row);
                i = 0;
                row = [textNoBorders, textNoBorders];
              }
            }
          });
          content.push(this.title(`${addOrder} ${this.additionalDetails[detail].props.label.toUpperCase()}`));
          content.push(additionalDetailsTable);
          addOrder += 1;
        });

        content.push(this.title(`${addOrder} ALLEKIRJOITUKSET`));
        signatureTable = {
          table: {
            dontBreakRows: true,
            unbreakable: true,
            widths: ['*'],
            body: [],
          },
          margin: [0, 0, 0, 0],
          layout: greyBorders(),
        };

        order = 1;
        this.signingSellers.forEach((seller) => {
          const chunk = (str, n) => {
            const ret = [];
            let idx;
            let len;

            for (idx = 0, len = str.length; idx < len; idx += n) {
              ret.push(str.substr(idx, n));
            }
            return ret;
          };

          const signature = this.signatures.find(signer => +signer.person_id === +seller.henkilo_id);
          const identification = [
            {
              table: {
                widths: ['*', 65, 75, 55, '*', '*'],
                body: [
                  [
                    {
                      text: `${addOrder}.${order}.${signature ? '3' : '2'} Tunnistus`,
                      fontSize: 6,
                      margin: [0, 0, 0, 0],
                      color: '#777777',
                    },
                    this.checkBox(' ', 'Ajokortti', 1, true, true, true),
                    this.checkBox(' ', 'Henkilökortti', 1, true, true, true),
                    this.checkBox(' ', 'Passi', 1, true, true, true),
                    this.checkBox(' ', 'Kuvallinen henkilökortti', 1, true, true, true),
                    this.checkBox(signature ? 'X' : ' ', 'Sähköinen tunnistautuminen', 1, true, true, true),
                  ],
                ],
              },
              margin: [0, 3, 0, -5],
              layout: 'noBorders',
            },
          ];
          let sellerRow = ' ';
          if (signature) {
            sellerRow = [this.pdfTable(`${addOrder}.${order} Allekirjoitus ja nimenselvennys`, `${signature.name} - Allekirjoitettu sähköisesti`, 1)];
            signatureTable.table.body.push(sellerRow);
            signatureTable.table.body.push([this.pdfTable(`${addOrder}.${order}.1 Paikka ja aika`, `${this.$options.filters.date(signature.created)} klo ${this.$options.filters.date(signature.created, { type: 'time' })}`)]);
            const signatureRow = [this.pdfTable(`${addOrder}.${order}.2 Sähköinen tunniste`, chunk(signature.signature, 135).join('\n'), 1, 1, 7)];
            signatureTable.table.body.push(signatureRow);
          } else {
            sellerRow = [this.pdfTable(`${addOrder}.${order} Allekirjoitus ja nimenselvennys`, `${seller.nimi ? seller.nimi : ' '}`, 1)];
            signatureTable.table.body.push(sellerRow);
            signatureTable.table.body.push([this.pdfTable(`${addOrder}.${order}.1 Paikka ja aika`, ' ')]);
          }
          signatureTable.table.body.push(identification);

          order += 1;
        });

        if (signatureTable.table.body.length > 0) {
          content.push(signatureTable);
        }

        addOrder += 1;
        order = 1;
        agentSign = {
          table: {
            widths: ['*'],
            body: [
              [
                this.pdfTable(`${addOrder}.${order} Välittäjän allekirjoitus`, `${this.property.agentName} - Allekirjoitettu sähköisesti` || ' ', 1),
              ],
            ],
          },
          layout: greyBorders(),
        };
        if (!this.oldVersion) {
          content.push(this.title(`${addOrder} VÄLITYSLIIKKEEN ALLEKIRJOITUKSET`));
          content.push(agentSign);
        }
      } // ADDITIONAL DETAILS PDF ENDS

      if (this.canceling && this.canceling.selectedAgent && this.side !== 'additional') {
        const agent = this.canceling.selectedAgent;
        const agentDetails = `${agent.name}, ${agent.email}, ${agent.address}`;
        const cancelTable = {
          table: {
            dontBreakRows: true,
            widths: ['*'],
            body: [
              this.canceling.tableRows[0],
              [{ columns: [this.pdfTable(`Peruuttaminen tulee osoittaa seuraavalle yrityksemme (${agent.companyName}) edustajalle`, agentDetails)], margin: [8, 8, 8, 8] }],
              this.canceling.tableRows[1],
              this.canceling.tableRows[2],
            ],
          },
          layout: greyBorders(),
          margin: [0, 8, 0, 8],
        };

        content.push({ text: ' ', pageBreak: 'before' });
        if (this.logo !== false && this.logo !== null) {
          content.push({
            image: this.logo, fit: [160, 50], width: 160, height: 50, margin: [0, 0, 0, 10],
          });
        }
        content.push('KOTIMYYNTISOPIMUS');
        content.push(cancelTable);
      }

      const docDefinition = {
        content,
        footer: (currentPage, pageCount) => ({
          color: '#666666',
          text: `${this.side === 'additional' ? 'Selostusliite' : 'Toimeksiantosopimus'}: ${this.property.kohdenimi} ${this.property.huoneistonro}  Sivu: ${currentPage.toString()} / ${pageCount}`,
          fontSize: 8,
          alignment: 'right',
          width: '50%',
          margin: [0, 2, 14, 4],
        }),
        header:
          {
            columns: [
              {
                color: '#666666',
                text: `${this.property.kohdenimi} ${this.property.huoneistonro}`,
                fontSize: 8,
                alignment: 'left',
                width: '50%',
                margin: [15, 15, 0, 0],
              }, {
                color: '#666666',
                text: `Toimeksianto: ${this.property.kohdenumero}`,
                fontSize: 8,
                alignment: 'right',
                width: '50%',
                margin: [0, 15, 15, 0],
              },
            ],
          },
        defaultStyle: {
          font: 'Roboto',
        },
        pageMargins: [15, 28, 15, 38],
        styles: {
          cells: {
            margin: [0, 5, 0, 5],
          },
          grayLines: {
            hLineColor: () => 'gray',
            vLineColor: () => 'gray',
          },
        },
      };
      const fileName = this.side === 'additional' ? 'Selostusliite.pdf' : 'Toimeksiantosopimus.pdf';
      pdfMake.createPdf(docDefinition).download(fileName);
    },

    async onChange(index) {
      if (!index) return;

      const target = `anchor-${index}`;

      const element = window.document.getElementById(target);

      if (!element) return;

      await sleep(600);

      window.requestAnimationFrame(() => element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      }));
    },
  },
};
</script>
<style lang="scss" scoped>
.property-details {
  ol {
    counter-reset: item;
  }
  li {
    display: block;
  }
  li:before {
    content: counters(item, ".") " ";
    counter-increment: item;
  }
}

.v-application .error--text {
  margin-bottom: 20px;
}

</style>
